if (!customElements.get('size-guide')) {
  const { Fancybox } = await import('@fancyapps/ui');
  class SizeGuide extends HTMLElement {
    constructor() {
      super();

      // Add fallback class if easysize container is not found
      if (!document.querySelector('.easysize-container')) {
        this.classList.add('fallback');
      }

      this.addEventListener('click', (e) => this.handleClick(e));
    }

    /**
     * Handle click event
     * On mobile (< 768px): Open overlay modal
     * On desktop (>= 768px): Open in new tab
     * @param {Event} e - Click event
     */
    handleClick(e) {
      e.preventDefault();
      const url = e.target?.dataset?.url | e.currentTarget?.dataset?.url || this.dataset.url;
      let fallback = this.classList.contains('fallback') || window.easysize_fallback;
      if (!url || !fallback) {
        this.clickEasySizeButton();
        return;
      }

      const isMobile = window.innerWidth < 768;

      if (isMobile) {
        this.openOverlay(url);
      } else {
        new Fancybox([
          {
            src: url,
            type: 'image',
          },
        ]);
      }
    }

    clickEasySizeButton() {
      var easysizeButton = document.querySelector('#easysize_button');
      if (easysizeButton) {
        easysizeButton.click();
      } else {
        // Retry if button doesn't exist yet
        setTimeout(() => this.clickEasySizeButton(), 100);
      }
    }

    /**
     * Open overlay modal (mobile only)
     * @param {string} url - URL to display
     */
    openOverlay(url) {
      const isPDF = /\.pdf(\?|#|$)/i.test(url);

      const overlay = document.createElement('div');
      overlay.className = 'size-guide-overlay';
      overlay.role = 'dialog';
      overlay.ariaModal = 'true';

      const frame = document.createElement('div');
      frame.className = 'size-guide-frame';
      overlay.appendChild(frame);

      // Content
      let node;
      if (isPDF) {
        node = document.createElement('iframe');
        node.src = url + (url.includes('#') ? '' : '#view=FitH');
      } else {
        node = document.createElement('img');
        node.src = url;
        node.alt = this.getAttribute('alt') || 'Size guide';
        node.decoding = 'async';
      }
      node.className = 'size-guide-content';
      frame.appendChild(node);

      // Close button
      const closeBtn = document.createElement('button');
      closeBtn.className = 'size-guide-close-btn';
      closeBtn.textContent = 'Close';
      closeBtn.addEventListener('click', () => this.close(overlay));
      overlay.appendChild(closeBtn);

      // Close on backdrop tap
      overlay.addEventListener('click', (ev) => {
        if (ev.target === overlay) this.close(overlay);
      });

      // Close on ESC
      const onKey = (ev) => ev.key === 'Escape' && this.close(overlay);
      document.addEventListener('keydown', onKey, { once: true });

      // Mount
      document.body.appendChild(overlay);
      document.body.classList.add('size-guide-no-scroll');
    }

    /**
     * Close overlay modal
     * @param {HTMLElement} overlay - Overlay element to remove
     */
    close(overlay) {
      overlay?.remove();
      document.body.classList.remove('size-guide-no-scroll');
    }
  }

  window.SizeGuide = SizeGuide;
  customElements.define('size-guide', SizeGuide);
}
